import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ElectronicDocumentTypeEnum } from 'src/app/enum/electronic-document-type-enum';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { NoteConceptTableModel } from 'src/app/models/tables/invoicing/note-concept-table.model';
import { NoteDetailTable } from 'src/app/models/tables/invoicing/note-detail-table.model';
import { NoteTableModel } from 'src/app/models/tables/invoicing/note-table.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { NoteConceptService } from 'src/app/services/invoicing/note-concept.service';
import { NoteDetailService } from 'src/app/services/invoicing/note-detail.service';
import { NoteService } from 'src/app/services/invoicing/note.service';
import { ElectronicDocumentInfoComponent } from '../../electronic-document-info/electronic-document-info.component';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  standalone: false
})
export class NoteComponent implements OnInit {

  @ViewChild('electronicDocumentInfo') electronicDocumentInfoComponent?: CustomModalComponent | null = null;

  isDocumentSupport: boolean = false;
  isOpened: string | undefined = undefined
  url: string = '';
  nameWindow: string = '';
  generalHeader: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<NoteTableModel> = new PagedResponseModel<NoteTableModel>();
  detailHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  detailData: PagedResponseModel<NoteDetailTable> = new PagedResponseModel<NoteDetailTable>();
  conceptHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  conceptData: PagedResponseModel<NoteConceptTableModel> = new PagedResponseModel<NoteConceptTableModel>();
  storeConsolidated: boolean = true;
  projectName = ProjectName.projectName;
  activeTabIndex = 0;
  inputsForElectronicDocumentInfo$ = new BehaviorSubject<any>({
    typeDocument: 0,
    documentId: 0
  });
  page: number = 1;
  limit: number = 10;
  columnSort: string | null = null;
  ascendant: boolean = true;
  filters: ColumnResponseModel[] = []
  previousSort: { field: string; isAscsendant: number };
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
    {
      label: 'Facturación Electrónica',
      icon: 'pi pi-receipt',
      action: 'info'
    }
  ];
  componentElectronicDocumentInfo = ElectronicDocumentInfoComponent;

  constructor(private noteService: NoteService,
    private noteDetailService: NoteDetailService,
    private noteConceptService: NoteConceptService,
    private router: Router,
    private headerService: HeaderService,
    private title: Title) {
    this.getUrl();
  }

  async ngOnInit() {
    this.nameWindow = this.isDocumentSupport ? 'Notas Ajuste Documento Soporte' : 'Notas'
    this.title.setTitle(`Notas -  ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getNotesWithPagination(),
    ]);
  }

  newNote() {
    this.router.navigate([`/${this.url}/register`]);
  }

  async getUrl() {
    let url = this.router.url as string;
    url = url.substring(1);
    this.url = url;
    //valido la url actual
    this.url == 'note' ? this.isDocumentSupport = false : this.isDocumentSupport = true;
  }

  async getAllNoteConceptsWithPagination() {
    try {
      this.conceptData = await firstValueFrom(this.noteConceptService.getAllNoteConceptsWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters, this.isDocumentSupport));
    } catch (error) {
      console.error('Error al buscar los conceptos de las notas.', error);
    }
  }

  async getAllNoteDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.noteDetailService.getAllNoteDetailsWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters, this.isDocumentSupport));
    } catch (error) {
      console.error('Error al buscar los detalles de las notas.', error);
    }
  }

  async getColumnsForConceptConsultation() {
    try {
      if (this.conceptHeader.columns.length === 0) {
        this.conceptHeader = await firstValueFrom(this.noteConceptService.getColumnsForConceptConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta consepto.', error);
    }
  }

  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.columns.length === 0) {
        this.detailHeader = await firstValueFrom(this.noteDetailService.getColumnsForDetailConsultation(this.isDocumentSupport));
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta detalle.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.noteService.getColumnsForGeneralConsultation(this.isDocumentSupport));
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getNotesWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.noteService.getNotesWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters, this.isDocumentSupport));
    } catch (error) {
      console.error('Error al buscar las Notas.', error);
    }
  }

  async exportDetailConsultation() {
    try {
      const response = await firstValueFrom(this.noteDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant, this.isDocumentSupport));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Notas Detalle.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar las notas detalle.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(this.noteService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant, this.isDocumentSupport));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Notas.xlsx'; // El nombre del archivo
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar las notas.', error);
    }
  }

  async exportConceptConsultation() {
    try {
      const blob = await firstValueFrom(this.noteConceptService.exportConceptConsultation(this.filters, this.columnSort, this.ascendant, this.isDocumentSupport));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Nota Concepto.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }

    } catch (error) {
      console.error('Error al exportar las notas concepto.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.columns.length = this.detailHeader.columns.length === 1 ? 0 : this.detailHeader.columns.length;
    this.conceptHeader.columns.length = this.conceptHeader.columns.length === 1 ? 0 : this.conceptHeader.columns.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getNotesWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getAllNoteDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 2:
        await Promise.all([
          this.getColumnsForConceptConsultation(),
          this.getAllNoteConceptsWithPagination()
        ]);
        this.conceptData = {
          ...this.conceptData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getNotesWithPagination()
        break;
      case 1:
        await this.getAllNoteDetailsWithPagination()
        break;
      case 2:
        await this.getAllNoteConceptsWithPagination()
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
      case 2:
        await this.exportConceptConsultation();
        break;
    }
  }

  onAction(event: { action: string, item?: NoteTableModel }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/${this.url}/register/${event.item.noteId}`]);
    }
    if (event.action === 'info' && event.item) {
      this.openElectronicDocumentInfo(event.item);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async openElectronicDocumentInfo(item: NoteTableModel) {
    this.inputsForElectronicDocumentInfo$.next({
      typeDocument: ElectronicDocumentTypeEnum.note,
      documentId: item.id
    });
    this.electronicDocumentInfoComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
